import { widgetId } from '../constants/widgetId'
import { WidgetId } from '../types/widgetId'

export const fullWidthWidgets: WidgetId[] = [widgetId.CashPilot, widgetId.Graph]

export const isFullWidthWidget = (widgetId: WidgetId) => {
  return fullWidthWidgets.includes(widgetId)
}
